<template>
  <div :id="`modal-${modalId}`">
    <MadModal
      :id="modalId"
      :data-cy="`${modalId}-modal`"
      :options="options"
      @opened="onOpened"
      @closed="onClosed"
    >
      <div class="modal-body">
        <b-tabs
          v-model="tabIndex"
          no-key-nav
        >
          <template>
            <b-tab :title="`${this.$i18n.t('JSON.domaintlds')}`">
              <div class="v-table">
                <TableServer type="domaintlds" />
              </div>
            </b-tab>
            <b-tab :title="`${this.$i18n.t('JSON.add-domaintld')}`">
              <DomainTldForm v-if="spawnerAdminSchemas.forms['DomainTld']" />
            </b-tab>
            <b-tab
              v-if="domaintldId !== null && adminDomainTld.id > 0"
              :title="`${this.$i18n.t('JSON.domaintld')}#${domaintldId}`"
            >
              <DomainTldForm
                v-if="spawnerAdminSchemas.forms['DomainTld']"
                :domaintld="adminDomainTld"
                mode="edit"
              />
            </b-tab>
          </template>
        </b-tabs>
      </div>
    </MadModal>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import formHelpers from '@/mixins/admin/helpers/form-helpers';
import modalHelpers from '@/mixins/admin/helpers/modal-helpers';

export default {

  components: {
    MadModal: () => import('@/components/MadModal'),
    DomainTldForm: () => import('@/components/admin/spawner/modals/forms/DomainTldForm'),
  },

  mixins: [
    formHelpers, //
    modalHelpers,
  ],

  props: {
    domaintldId: {
      type: Number,
      default: () => 0,
    },
  },

  data() {
    return {
      options: {
        width: '75%',
        //   height: '95%',
      },
    };
  },

  computed: {
    ...mapState({
      adminDomainTld: (state) => state.adminDomainTld.adminDomainTld,
    }),

    modalId() {
      return 'domaintld';
    },
  },

  watch: {
    domaintldId(newValue) {
      if (newValue !== null) {
        this.loadSpawnerAdminDomainTld();
      }
    },
  },

  methods: {
    ...mapActions(['getSpawnerAdminDomainTld']),

    async loadSpawnerAdminDomainTld() {
      try {
        await this.getSpawnerAdminDomainTld({
          params: {
            tid: this.domaintldId,
          },
        });

        // console.log('domaintld', this.domaintld);

        // success
        // console.log('success loading domaintld!');
      } catch (error) {
        // error
        // console.log('error loading domaintld!');
      }
    },

    onOpened() {
      if (this.domaintldId !== null) {
        this.loadSpawnerAdminDomainTld();
      }

      this.modalOpened();
    },

    onClosed() {
      this.modalClosed();
    },
  },
};
</script>
